import {
  SET_CONVERSATION_RATING_SCORE,
  SET_CONVERSATION_RATING_SCORE_DATA,
  DELETE_CONVERSATION_RATING,
} from 'actions/types';

export const setRatingScore = (conversationId, ratingScore) => ({
  type: SET_CONVERSATION_RATING_SCORE,
  payload: { conversationId, ratingScore },
});

export const setRatingScoreData = (conversationId, ratingScore, ratingScoreData) => ({
  type: SET_CONVERSATION_RATING_SCORE_DATA,
  payload: {
    conversationId,
    ratingScore,
    ratingScoreData,
  },
});

export const deleteRating = (conversationId) => ({
  type: DELETE_CONVERSATION_RATING,
  payload: { conversationId },
});
